export default __webpack_public_path__ + "static/npl_logo.inline-5f87486a37a3d62b4d45de145433bcaa.png";